// GA4接入
function Gtag(userId) {
  const gtag = window.gtag;
  if (!gtag) return;
  const tagId = process.env.GTAG;
  const uId = userId ? `${userId + 25}` : "none";

  // 初始化配置。
  gtag("config", tagId, {
    // user_id用于跨设备识别用户。
    user_id: uId,
  });

  return gtag;
}

export default Gtag;



// WEBPACK FOOTER //
// ./src/lego/gTag.js